import React from 'react';
import moment from 'moment';
import { Icon } from 'semantic-ui-react';
import { STRING_DATE_PARSE_FORMATS } from './emissionEntryDefaults';

const formatTabDate = (stringDate) => {
  const m = moment(stringDate, STRING_DATE_PARSE_FORMATS, true);
  return m.isValid() ? m.format('DD/MM/YYYY') : stringDate;
};

const JournalEntryDraftTabs = ({
  drafts,
  activeIndex,
  onSelect,
  getPeriodLock,
  getTabLabel,
  getValidation,
  truncateLabel = false,
}) => {
  if (!drafts || drafts.length <= 1) return null;

  return (
    <div className="journal-entry-draft-tabs" role="tablist">
      {drafts.map((draft, index) => {
        const periodLock = getPeriodLock(draft.stringDate);
        const validation = getValidation ? getValidation(draft) : null;
        const tabLabel = getTabLabel
          ? getTabLabel(draft, index)
          : `Asiento ${index + 1}`;
        const dateLabel = formatTabDate(draft.stringDate);

        return (
          <button
            key={draft.documentId ?? draft.id ?? index}
            type="button"
            role="tab"
            aria-selected={index === activeIndex}
            title={tabLabel}
            className={[
              'journal-entry-draft-tab',
              index === activeIndex ? 'journal-entry-draft-tab--active' : '',
              validation && !validation.isValid ? 'journal-entry-draft-tab--invalid' : '',
              periodLock.isLocked ? 'journal-entry-draft-tab--locked' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            onClick={() => onSelect(index)}
          >
            <span
              className={[
                'journal-entry-draft-tab__label',
                truncateLabel ? 'journal-entry-draft-tab__label--truncate' : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {tabLabel}
            </span>
            <span className="journal-entry-draft-tab__meta">{dateLabel}</span>
            {periodLock.isLocked && (
              <Icon name="lock" className="journal-entry-draft-tab__icon" />
            )}
            {validation && !periodLock.isLocked && !validation.isBalanced && validation.hasLines && (
              <Icon name="exclamation circle" className="journal-entry-draft-tab__icon" />
            )}
            {validation && !periodLock.isLocked && !validation.hasLines && (
              <Icon name="warning sign" className="journal-entry-draft-tab__icon" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default JournalEntryDraftTabs;
